import React from 'react';

export const CompressedIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-compresed"
      style={{
        color: '#757575',
        ...props.style
      }}
    />
  );
};
